import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import ddLogo from '../Assets/img/logo-DD-W.svg';
import ddLogoDark from '../Assets/img/logo-dd-dark.svg';
import iconInsta from '../Assets/img/icons/icon-insta.svg';
import iconTwitter from '../Assets/img/icons/icon-twitter.svg';
import iconFacebook from '../Assets/img/icons/icon-facebook.svg';

const Footer = () => {
    return (
        <footer>
            <div class="container">
                <div class="footer-top">
                    <div class="footer-logo">
                        <Link to="https://datadeli.in/">
                            <img src={ddLogoDark} alt="logo" />
                        </Link>
                    </div>
                           <div class="">
                    Copyright © 2025 DataDeli. All rights Reserved. <span>&bull;</span>
                    <Link to="/PrivacyPolicy">Privacy Policy</Link>  <span>&bull;</span> <Link to="/termsofservice">Terms and Conditions</Link>
                </div>
                    {/* <div class="footer-social">
                        <ul>
                            <li><a href="javascript:;"><img src={iconInsta} alt="" /></a></li>
                            <li><a href="javascript:;"><img src={iconTwitter} alt="" /></a></li>
                            <li><a href="javascript:;"><img src={iconFacebook} alt="" /></a></li>
                        </ul>
                    </div> */}
                </div>
                {/* <div class="container">
                    Copyright © 2025 DataDeli. All rights Reserved. <span>&bull;</span>
                    <Link to="/PrivacyPolicy">Privacy Policy</Link>  <span>&bull;</span> <Link to="/termsofservice">Terms and Conditions</Link>
                </div> */}
            </div>
        </footer>

    );
}

export default Footer;